export enum Routes {
  MainMenu = "/",
  BuildingRandomiser = "/building-randomiser",
  Rules = "/rules",
}
